import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Candidates = () => {
  const navigate = useNavigate();
  const [activeFaculty, setActiveFaculty] = useState('engineering');
  const [activeDepartment, setActiveDepartment] = useState(null);
  const [candidateVotes, setCandidateVotes] = useState({});
  const [loading, setLoading] = useState(true);
  
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

  // Fetch real vote counts from backend
  useEffect(() => {
    const fetchVoteCounts = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/public/statistics`);
        if (response.ok) {
          const data = await response.json();
          setCandidateVotes(data.candidate_votes || {});
        }
      } catch (error) {
        console.error('Error fetching vote counts:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchVoteCounts();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchVoteCounts, 30000);
    return () => clearInterval(interval);
  }, [BACKEND_URL]);
  
  const candidatesData = {
    engineering: [
      {
        id: 'computer',
        department: 'انجمن علمی مهندسی کامپیوتر',
        icon: 'laptop-code',
        color: '#3B82F6',
        candidates: [
          { id: 1, name: 'علی محمد شاه‌حسینی', gender: 'male', photo: 'https://i.postimg.cc/HnRwp5jb/IMG-20251119-223955-992.jpg' },
          { id: 2, name: 'عرفان تبار‌ملاحسن', gender: 'male', photo: 'https://i.postimg.cc/g0YQCr7X/IMG-20251117-140951-442.jpg' },
          { id: 3, name: 'نگار توسلی', gender: 'female', photo: 'https://i.postimg.cc/pTQfxpDM/IMG-20251114-215112-735.jpg' },
          { id: 4, name: 'زهرا محمدی', gender: 'female', photo: null },
          { id: 5, name: 'هادی مستوفی‌زاده', gender: 'male', photo: 'https://i.postimg.cc/d1R2vLGB/IMG-20251114-215051-745.jpg' },
          { id: 6, name: 'نیوشا اللّه‌دادی', gender: 'female', photo: 'https://i.postimg.cc/4xbZF73j/4960986466301446957.jpg' },
          { id: 7, name: 'ابوالفضل علیزاده', gender: 'male', photo: 'https://i.postimg.cc/ZRP8ZC6x/IMG-20251114-184832-710.jpg' },
          { id: 8, name: 'علی اصغر اقبال', gender: 'male', photo: 'https://i.postimg.cc/Jn3NmGj3/IMG-20251114-215051-903.jpg' },
          { id: 9, name: 'ابوالفضل اصغری', gender: 'male', photo: 'https://i.postimg.cc/Hx0wHVb3/IMG-20251114-215052-393.jpg' }
        ]
      },
      {
        id: 'chemical',
        department: 'انجمن علمی مهندسی شیمی',
        icon: 'flask',
        color: '#F59E0B',
        candidates: [
          { id: 10, name: 'ابوالفضل قربانی', gender: 'male', photo: 'https://i.postimg.cc/MTRgWrf6/IMG-5158.jpg' },
          { id: 11, name: 'امیر یزدان‌ پناه', gender: 'male', photo: null },
          { id: 12, name: 'مهدی علیزاده', gender: 'male', photo: 'https://i.postimg.cc/zvJnf8k6/IMG-20251114-215101-412.jpg' },
          { id: 13, name: 'شقایق صادقی', gender: 'female', photo: null },
          { id: 14, name: 'فاطمه نعیمی', gender: 'female', photo: 'https://i.postimg.cc/xdwQFv2j/5821451858038426580.jpg' },
          { id: 15, name: 'محمدفاضل ولی پور', gender: 'male', photo: 'https://i.postimg.cc/0jF2xTgV/5823327354292472698.jpg' },
          { id: 16, name: 'پارمیدا حبیبی شور کچالی', gender: 'female', photo: 'https://i.postimg.cc/KcLPVxng/5823272288516770569.jpg' },
          { id: 17, name: 'ماهک عنایتی', gender: 'female', photo: null },
          { id: 18, name: 'عرشیا وحیدی', gender: 'male', photo: 'https://i.postimg.cc/rwq7sh8G/4960986466301446955.jpg' },
          { id: 19, name: 'کیانا نجف نژاد', gender: 'female', photo: 'https://i.postimg.cc/0j8pNPfx/IMG-20251114-215111-717.jpg' }
        ]
      },
      {
        id: 'architecture',
        department: 'انجمن علمی مهندسی معماری',
        icon: 'drafting-compass',
        color: '#10B981',
        candidates: [
          { id: 20, name: 'رضا بیاتی', gender: 'male', photo: null },
          { id: 21, name: 'سیده فاطمه حسینی', gender: 'female', photo: 'https://i.postimg.cc/SKJrxkLx/IMG000-(1).jpg' },
          { id: 22, name: 'آرزو رسولی', gender: 'female', photo: null },
          { id: 23, name: 'نادیا شرامه', gender: 'female', photo: null },
          { id: 24, name: 'یلدا زندی زیارانی', gender: 'female', photo: null },
          { id: 105, name: 'مهدی رمضانی', gender: 'male', photo: null },
          { id: 106, name: 'مریم رزقی', gender: 'female', photo: null },
          { id: 107, name: 'پرستو ولی', gender: 'female', photo: null },
          { id: 108, name: 'هلیا پارسایان', gender: 'female', photo: null },
          { id: 109, name: 'معصومه معینی', gender: 'female', photo: null },
          { id: 110, name: 'رومینا حسین‌زاده', gender: 'female', photo: null },
          { id: 111, name: 'معصومه ازوی', gender: 'female', photo: null }
        ]
      },
      {
        id: 'mechanical',
        department: 'انجمن علمی مهندسی مکانیک',
        icon: 'cogs',
        color: '#EC4899',
        candidates: [
          { id: 25, name: 'محمد رسول قربانی', gender: 'male', photo: null },
          { id: 26, name: 'مهدی ایمانی', gender: 'male', photo: 'https://i.postimg.cc/QNbtVzD2/5819017388970675257.jpg' },
          { id: 27, name: 'حامد یزدانی', gender: 'male', photo: 'https://i.postimg.cc/tTFsrRLJ/5819211972464020467.jpg' },
          { id: 28, name: 'میثم ابراهیم پور ملکشاه', gender: 'male', photo: null },
          { id: 29, name: 'محمد رنجبر', gender: 'male', photo: 'https://i.postimg.cc/Wz2M4TnD/IMG-20251114-215110-259.jpg' }
        ]
      },
      {
        id: 'civil',
        department: 'انجمن علمی مهندسی عمران',
        icon: 'building',
        color: '#8B5CF6',
        candidates: [
          { id: 30, name: 'امیررضا اکبری', gender: 'male', photo: null },
          { id: 31, name: 'هدیه شکیبایی مرام', gender: 'female', photo: null },
          { id: 32, name: 'مهدی اجواری', gender: 'male', photo: 'https://i.postimg.cc/1XJDn2C0/IMG-20251114-215118-844.jpg' },
          { id: 33, name: 'امیرمحمد جوکار', gender: 'male', photo: 'https://i.postimg.cc/2y2nbMcL/IMG-20251114-215117-471.jpg' },
          { id: 34, name: 'مهدیسا آقاگلی', gender: 'female', photo: null },
          { id: 35, name: 'علی فرهادی', gender: 'male', photo: null },
          { id: 37, name: 'سید محمد یاسین حسنی', gender: 'male', photo: null },
          { id: 38, name: 'سهیل تقوی', gender: 'male', photo: null },
          { id: 39, name: 'امیرحسین رضایی', gender: 'male', photo: null },
          { id: 40, name: 'فریبرز علایی', gender: 'male', photo: null }
        ]
      },
      {
        id: 'industrial',
        department: 'انجمن علمی مهندسی صنایع',
        icon: 'industry',
        color: '#06B6D4',
        candidates: [
          { id: 41, name: 'مریم شهروزی', gender: 'female', photo: null },
          { id: 42, name: 'پارسا شایان فر', gender: 'male', photo: null },
          { id: 43, name: 'ابوالفضل احمدی', gender: 'male', photo: null },
          { id: 44, name: 'مریم رضازاده', gender: 'female', photo: null },
          { id: 45, name: 'امیرحسین غلامی بایی', gender: 'male', photo: null },
          { id: 46, name: 'نوید رضا قلی زاده', gender: 'male', photo: null }
        ]
      },
      {
        id: 'biomedical',
        department: 'انجمن علمی برق-پزشکی',
        icon: 'heartbeat',
        color: '#EF4444',
        candidates: [
          { id: 47, name: 'امیررضا اکبرزاده', gender: 'male', photo: 'https://i.postimg.cc/RhCRtCSv/IMG-20251122-184946-734.jpg' },
          { id: 48, name: 'محمدجواد پناه', gender: 'male', photo: 'https://i.postimg.cc/yY7BKvgQ/IMG-20251123-112749-618.jpg' },
          { id: 49, name: 'پرستو بابایی', gender: 'female', photo: 'https://i.postimg.cc/mkbQrBws/IMG-20251114-215107-446.jpg' },
          { id: 50, name: 'کوثر نجفی مرزان', gender: 'female', photo: 'https://i.postimg.cc/L5NjYwCD/IMG-20251114-215121-705.jpg' },
          { id: 51, name: 'فاطمه زهرا ثقفی', gender: 'female', photo: null },
          { id: 112, name: 'محمد قاسمی', gender: 'male', photo: null },
          { id: 113, name: 'روناز مینا خانی', gender: 'female', photo: null },
          { id: 114, name: 'فاطمه رمضانی', gender: 'female', photo: null },
          { id: 115, name: 'فاطمه زهرا موسوی کنتی', gender: 'female', photo: null },
          { id: 116, name: 'امیر حسین رحمانی', gender: 'male', photo: null },
          { id: 117, name: 'امیر رضا شهابی', gender: 'male', photo: null },
          { id: 118, name: 'مهدی ابو طالبی', gender: 'male', photo: 'https://i.postimg.cc/4yZjcw6x/5825440542626614132.jpg' },
          { id: 119, name: 'امیر علی پور اسحاق', gender: 'male', photo: 'https://i.postimg.cc/d3vgCn2w/5823281896358612216.jpg' }
        ]
      },
      {
        id: 'surveying',
        department: 'انجمن علمی مهندسی نقشه‌برداری',
        icon: 'map-marked-alt',
        color: '#F97316',
        candidates: [
          { id: 52, name: 'امیرحسین اسدی', gender: 'male', photo: null },
          { id: 53, name: 'حسین قنبری گنگرکلا', gender: 'male', photo: null },
          { id: 54, name: 'سام موسوی', gender: 'male', photo: null },
          { id: 55, name: 'فاطمه زهرا پرتوی', gender: 'female', photo: null },
          { id: 56, name: 'رضوان فلاحی مقدم', gender: 'male', photo: null },
          { id: 57, name: 'طهورا حجازی مرزنگو', gender: 'female', photo: null },
          { id: 58, name: 'رایکا کاویان پور', gender: 'female', photo: null }
        ]
      }
    ],
    humanities: [
      {
        id: 'management',
        department: 'انجمن علمی مدیریت',
        icon: 'briefcase',
        color: '#3B82F6',
        candidates: [
          { id: 60, name: 'امیرحسین یزدانی', gender: 'male', photo: null },
          { id: 61, name: 'علی حسین‌زاده', gender: 'male', photo: null },
          { id: 62, name: 'سید محمد حسینی', gender: 'male', photo: null },
          { id: 63, name: 'سمانه حاجی‌پور', gender: 'female', photo: null },
          { id: 64, name: 'ملیسا اصغری', gender: 'female', photo: null },
          { id: 65, name: 'بیتا اصغری', gender: 'female', photo: null },
          { id: 66, name: 'دنیا فتح‌الله‌پور', gender: 'female', photo: null },
          { id: 120, name: 'سیده ماهان طباطبایی', gender: 'female', photo: null }
        ]
      },
      {
        id: 'psychology',
        department: 'انجمن علمی روانشناسی',
        icon: 'brain',
        color: '#F59E0B',
        candidates: [
          { id: 71, name: 'آنیتا خاکپور', gender: 'female', photo: null },
          { id: 72, name: 'ماهتیسا قنبری', gender: 'female', photo: null },
          { id: 73, name: 'پویا موخر', gender: 'male', photo: null },
          { id: 74, name: 'سپیده عسگری', gender: 'female', photo: null },
          { id: 75, name: 'فاطمه سعادتی', gender: 'female', photo: null },
          { id: 76, name: 'نسیم عابدی', gender: 'female', photo: null },
          { id: 77, name: 'فاطمه طهماسب', gender: 'female', photo: null },
          { id: 121, name: 'ساجده عباسی', gender: 'female', photo: null }
        ]
      },
      {
        id: 'accounting',
        department: 'انجمن علمی حسابداری',
        icon: 'calculator',
        color: '#10B981',
        candidates: [
          { id: 78, name: 'سید مهدی حسینی ایمنی', gender: 'male', photo: null },
          { id: 79, name: 'محمد حسین یزدی', gender: 'male', photo: null },
          { id: 80, name: 'محمد امین کریمی', gender: 'male', photo: null },
          { id: 81, name: 'مهدی موسوی چاشمی', gender: 'male', photo: null },
          { id: 82, name: 'شراگیم للهی حاجی دلایی', gender: 'male', photo: null },
          { id: 122, name: 'زهرا ابراهیمی', gender: 'female', photo: null },
          { id: 123, name: 'محمد حسین مختاری', gender: 'male', photo: null }
        ]
      },
      {
        id: 'law',
        department: 'انجمن علمی حقوق',
        icon: 'balance-scale',
        color: '#EF4444',
        candidates: [
          { id: 87, name: 'سحر احمدزاده', gender: 'female', photo: null },
          { id: 88, name: 'رضا توسلی', gender: 'male', photo: 'https://i.postimg.cc/tJXhgp5V/IMG-20251114-215108-762.jpg' },
          { id: 89, name: 'حنانه دلفان آذری', gender: 'female', photo: 'https://i.postimg.cc/2y2nbMc9/IMG-20251114-215133-970.jpg' },
          { id: 90, name: 'فاطمه خضرایی', gender: 'female', photo: null },
          { id: 91, name: 'ستایش وحیدی', gender: 'female', photo: null },
          { id: 92, name: 'مهنا زمینی', gender: 'female', photo: null },
          { id: 93, name: 'آرمان علی‌بابایی', gender: 'male', photo: null },
          { id: 94, name: 'حسن توکلی', gender: 'male', photo: null },
          { id: 95, name: 'ابوالفضل قلی‌نژاد عمران', gender: 'male', photo: 'https://i.postimg.cc/Fz9jKNZk/IMG-20251114-215113-308.jpg' },
          { id: 96, name: 'سپهر جعفری', gender: 'male', photo: 'https://i.postimg.cc/nrHvLpkV/IMG-20251114-215103-644.jpg' },
          { id: 124, name: 'محمد شکری زاده', gender: 'male', photo: 'https://i.postimg.cc/C1fKhbTC/IMG-3532.avif' },
          { id: 125, name: 'محمد طاها عباسی', gender: 'male', photo: 'https://i.postimg.cc/VvQkd5m3/5805312139739204744.jpg' }
        ]
      }
    ],
    sports: [
      {
        id: 'physical',
        department: 'انجمن علمی تربیت بدنی و علوم ورزشی',
        icon: 'running',
        color: '#8B5CF6',
        candidates: [
          { id: 97, name: 'سارینا صانعی ماتک', gender: 'female', photo: 'https://i.postimg.cc/prqKh4Gr/IMG-20251114-215102-768.jpg' },
          { id: 98, name: 'سیده فاطمه تقوی', gender: 'female', photo: null },
          { id: 99, name: 'زهرا رضایی', gender: 'female', photo: 'https://i.postimg.cc/rFg216Y8/5821060968769850376.jpg' },
          { id: 100, name: 'نرجس غلامی', gender: 'female', photo: null },
          { id: 101, name: 'عرفان بهنام', gender: 'male', photo: 'https://i.postimg.cc/pyMbsRML/5825815072364760288.jpg' },
          { id: 102, name: 'سجاد زارع', gender: 'male', photo: null },
          { id: 103, name: 'ماهان تقی پور', gender: 'male', photo: 'https://i.postimg.cc/hvpVz6yp/IMG-20251114-215119-732.jpg' },
          { id: 104, name: 'سید حسین حسینی', gender: 'male', photo: 'https://i.postimg.cc/nrVkmVFt/IMG-20251122-185157-052.jpg' }
        ]
      }
    ]
  };

  // Scroll to candidates section when department is selected
  useEffect(() => {
    if (activeDepartment) {
      // Scroll to the candidates section smoothly
      const candidatesSection = document.querySelector('.candidates-detail');
      if (candidatesSection) {
        const yOffset = -100; // Offset for header
        const y = candidatesSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [activeDepartment]);

  // Reset active department when faculty changes
  const handleFacultyChange = (faculty) => {
    setActiveFaculty(faculty);
    setActiveDepartment(null);
  };

  // Handle navigation to voting page
  const handleVoteNavigation = (candidateId, candidateName, departmentName) => {
    // Save candidate info to localStorage for the voting page
    localStorage.setItem('selectedCandidate', JSON.stringify({
      id: candidateId,
      name: candidateName,
      department: departmentName
    }));
    
    // Navigate to voting page using React Router
    navigate('/voting');
  };

  // Sort candidates by vote count
  const sortCandidatesByVotes = (candidates) => {
    if (!candidates) return [];
    
    // Check if all candidates have 0 votes
    const hasAnyVotes = candidates.some(candidate => (candidateVotes[candidate.id] || 0) > 0);
    
    // If no votes yet, keep original order
    if (!hasAnyVotes) {
      return [...candidates];
    }
    
    // Sort by vote count (highest to lowest)
    return [...candidates].sort((a, b) => {
      const votesA = candidateVotes[a.id] || 0;
      const votesB = candidateVotes[b.id] || 0;
      return votesB - votesA;
    });
  };

  return (
    <section className="candidates" id="about">
      <div className="container">
        <div className="section-title">
          <h2>نامزدهای انتخابات انجمن‌های علمی</h2>
          <p>با برنامه‌های نامزدها آشنا شده و به بهترین گزینه رأی دهید</p>
        </div>

        {/* Faculty Tabs */}
        <div className="faculty-tabs">
          <button 
            className={`faculty-tab ${activeFaculty === 'engineering' ? 'active' : ''}`} 
            onClick={() => handleFacultyChange('engineering')}
          >
            <i className="fas fa-cogs"></i>
            دانشکده فنی و مهندسی
          </button>
          <button 
            className={`faculty-tab ${activeFaculty === 'humanities' ? 'active' : ''}`} 
            onClick={() => handleFacultyChange('humanities')}
          >
            <i className="fas fa-book"></i>
            دانشکده علوم انسانی
          </button>
          <button 
            className={`faculty-tab ${activeFaculty === 'sports' ? 'active' : ''}`} 
            onClick={() => handleFacultyChange('sports')}
          >
            <i className="fas fa-running"></i>
            دانشکده علوم ورزشی
          </button>
        </div>

        {/* Department Selection */}
        {!activeDepartment && (
          <div className="departments-grid">
            {candidatesData[activeFaculty].map(dept => (
              <div 
                key={dept.id} 
                className="department-card"
                onClick={() => setActiveDepartment(dept.id)}
              >
                <div className="department-icon" style={{ backgroundColor: dept.color }}>
                  <div className="icon-container">
                    <i className={`fas fa-${dept.icon}`}></i>
                  </div>
                </div>
                <h3>{dept.department}</h3>
                <div className="candidate-count">
                  <i className="fas fa-users"></i>
                  <span>{dept.candidates.length} نامزد</span>
                </div>
                <button className="btn btn-outline">
                  مشاهده نامزدها
                  <i className="fas fa-arrow-left"></i>
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Candidates List */}
        {activeDepartment && (
          <div className="candidates-detail">
            <div className="candidates-header">
              <button 
                className="back-btn"
                onClick={() => setActiveDepartment(null)}
              >
                <i className="fas fa-arrow-right"></i>
                بازگشت به لیست رشته‌ها
              </button>
              
              {(() => {
                const dept = candidatesData[activeFaculty].find(d => d.id === activeDepartment);
                return dept ? (
                  <>
                    <div className="department-title">
                      <div className="department-icon" style={{ backgroundColor: dept.color }}>
                        <div className="icon-container">
                          <i className={`fas fa-${dept.icon}`}></i>
                        </div>
                      </div>
                      <h3>{dept.department}</h3>
                    </div>
                    <div className="candidate-count">
                      <i className="fas fa-users"></i>
                      <span>{dept.candidates.length} نامزد</span>
                    </div>
                  </>
                ) : null;
              })()}
            </div>
            
            <div className="candidates-list">
              {(() => {
                const dept = candidatesData[activeFaculty].find(d => d.id === activeDepartment);
                if (!dept) return null;
                
                const sortedCandidates = sortCandidatesByVotes(dept.candidates);
                
                return sortedCandidates.map(candidate => (
                  <div key={candidate.id} className="candidate-card">
                    <div className="candidate-header">
                      <div className="candidate-avatar" style={{ 
                        width: '80px', 
                        height: '80px', 
                        flexShrink: 0,
                        overflow: 'hidden',
                        borderRadius: '50%'
                      }}>
                        {candidate.photo ? (
                          <img 
                            src={candidate.photo} 
                            alt={candidate.name}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                              objectPosition: 'center'
                            }}
                          />
                        ) : (
                          <div className={`avatar-circle ${candidate.gender}`}>
                            <div className="avatar-icon">
                              <i className="fas fa-user"></i>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="candidate-name-votes">
                        <h4>{candidate.name}</h4>
                        <div className="vote-count">
                          <i className="fas fa-vote-yea"></i>
                          <span>
                            {loading ? '...' : (candidateVotes[candidate.id] || 0)} رأی
                          </span>
                        </div>
                      </div>
                    </div>
                    
                    <div className="candidate-actions">
                      <button 
                        className="btn btn-primary"
                        onClick={() => handleVoteNavigation(candidate.id, candidate.name, dept.department)}
                      >
                        <i className="fas fa-check-circle"></i>
                        رأی دادن به این نامزد
                      </button>
                    </div>
                  </div>
                ));
              })()}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Candidates;
